import {
  createWarehouse,
  deleteWarehouse,
  getType,
  getWarehouses,
  updateWarehouse,
} from '../actions/warehouses';
import { INIT_STATE } from './state';

export default function warehousesReducers(
  state = INIT_STATE.warehouses,
  action
) {
  const { type, payload } = action;

  switch (type) {
    case getType(getWarehouses.getWarehousesRequest()):
      return {
        ...state,
        loading: true,
      };

    case getType(getWarehouses.getWarehousesSuccess()):
      return {
        ...state,
        loading: false,
        data: payload,
      };

    case getType(getWarehouses.getWarehousesFailure()):
      return {
        ...state,
        loading: false,
      };

    case getType(createWarehouse.createWarehouseSuccess()):
      return {
        ...state,
        loading: false,
        data: [...state.data, payload],
      };

    case getType(createWarehouse.createWarehouseFailure()):
      return {
        ...state,
        loading: false,
      };

    case getType(updateWarehouse.updateWarehouseSuccess()):
      return {
        ...state,
        loading: false,
        data: state.data.map((warehouse) =>
          warehouse.id === payload.id ? payload : warehouse
        ),
      };

    case getType(updateWarehouse.updateWarehouseFailure()):
      return {
        ...state,
        loading: false,
      };

    case getType(deleteWarehouse.deleteWarehouseSuccess()):
      return {
        ...state,
        loading: false,
        data: state.data.filter((warehouse) => warehouse.id !== payload.id),
      };

    case getType(deleteWarehouse.deleteWarehouseFailure()):
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
